/**
 * @description
 *
 * Добавляет обработчик загрузки DOM.
 */

function onDocumentReady(callback: () => void) {
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', callback, { once: true })
  } else {
    setTimeout(callback, 0)
  }
}

export default onDocumentReady
